"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _layout = _interopRequireDefault(require("@/layout"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); } // +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var productRouter = {
  path: '/product',
  component: _layout.default,
  redirect: '/product/category',
  name: 'Product',
  meta: {
    title: '商品',
    icon: 'clipboard'
  },
  children: [{
    path: 'list',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/product/index'));
      });
    },
    name: 'ProductIndex',
    meta: {
      title: '商品列表',
      icon: ''
    }
  }, {
    path: 'category',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/product/category/index'));
      });
    },
    name: 'ProductCategory',
    meta: {
      title: '商品分类',
      icon: ''
    }
  }, {
    path: 'comment',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/product/comment/index'));
      });
    },
    name: 'ProductComment',
    meta: {
      title: '商品评论',
      icon: ''
    }
  }, {
    path: 'brand',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/product/brand/index'));
      });
    },
    name: 'ProductBrand',
    meta: {
      title: '品牌管理',
      icon: ''
    }
  }, {
    path: 'guarantee',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/product/guarantee/index'));
      });
    },
    name: 'ProductGuarantee',
    meta: {
      title: '保障服务',
      icon: ''
    }
  }, {
    path: 'tag',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/product/tag/index'));
      });
    },
    name: 'ProductTag',
    meta: {
      title: '商品标签',
      icon: ''
    }
  }, {
    path: 'tag/creatTag/:id?',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/product/tag/creatTag'));
      });
    },
    name: 'CreatTag',
    meta: {
      title: '添加商品标签',
      icon: '',
      noCache: true,
      activeMenu: "/product/tag"
    }
  }]
};
var _default = exports.default = productRouter;